<template>
  <IdentifyTop next-page-id="mb035">
    <template #wizard>
      <WizardGroup class="_mb-sm-35 _mb-md-50">
        <MainWizard
          :active-index="0"
          type="useridentity"
          class="_mb-sm-35 _mb-md-50"
        ></MainWizard>
      </WizardGroup>
    </template>
  </IdentifyTop>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifyTop from "@/components/fileupload/IdentifyTop";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";

export default {
  name: "Mb038",
  components: {
    MainWizard,
    WizardGroup,
    IdentifyTop,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,本人確認書類",
    });
  },
};
</script>

<style lang="scss" scoped></style>
